module.exports = __webpack_public_path__ + "static/media/tour-rec-blue.099810fa.svg";